import { buildScopedI18n } from '../../utils/buildScopedI18n';
import tplEsCL from './locales/es-CL.json';
import tplEnUS from './locales/en-US.json';
import tplPtBR from './locales/pt-BR.json';

export const escriturasTemplatesI18n = buildScopedI18n({
  esCL: tplEsCL,
  enUS: tplEnUS,
  ptBR: tplPtBR,
});
